module.exports = __webpack_public_path__ + "static/Portfolio10-1ff212cff3f723e818748b3eae5dc6ae.jpg";